import { useState } from 'react';
import { Button } from '../design-system/atoms/Button';
import { Card } from '../design-system/atoms/Card';
import { EmptyState } from '../design-system/atoms/EmptyState';
import { Spinner } from '../design-system/atoms/Spinner';
import { C } from '../design-system/tokens';

export function RoleLoadingState({ label }: { label: string }) {
  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18 }}>
      <Card style={{ width: '100%', maxWidth: 420 }}>
        <Spinner label={label} />
      </Card>
    </div>
  );
}

export function RoleFallbackScreen({
  icon,
  title,
  text,
  actionLabel,
  onAction,
}: {
  icon: string;
  title: string;
  text: string;
  actionLabel?: string;
  onAction?: () => Promise<void> | void;
}) {
  const [pending, setPending] = useState(false);

  async function handleAction() {
    if (!onAction || pending) return;
    setPending(true);
    try {
      await onAction();
    } finally {
      setPending(false);
    }
  }

  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18 }}>
      <Card style={{ width: '100%', maxWidth: 420, display: 'grid', gap: 12 }}>
        <EmptyState icon={icon} title={title} text={text} />
        {actionLabel && onAction ? (
          <Button fw col="ghost" disabled={pending} ch={pending ? '...' : actionLabel} onClick={() => void handleAction()} />
        ) : null}
        <div style={{ fontSize: 11, color: C.dim, textAlign: 'center', lineHeight: 1.5 }}>
          Если проблема повторяется, проверьте membership-запись пользователя в компании.
        </div>
      </Card>
    </div>
  );
}
